import { Navigate, Route, Routes } from "react-router-dom";
import { ADMIN_ROUTE_PATH } from "./adminConfig";
import LabDetailPage from "./components/LabDetailPage";
import AssociationLandingPage from "./pages/AssociationLandingPage";
import HomePage from "./pages/HomePage";
import AdminPage from "./pages/AdminPage";
import LabPollResultsPage from "./pages/LabPollResultsPage";
import HubPage from "./pages/PortalPage";
import ResourcesPage from "./pages/ResourcesPage";
import SubscriptionManagePage from "./pages/SubscriptionManagePage";

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/hub" element={<HubPage />} />
      <Route path="/portal" element={<Navigate to="/hub" replace />} />
      <Route path="/resources" element={<ResourcesPage />} />
      <Route path="/association/:slug" element={<AssociationLandingPage />} />
      <Route path="/lab/:id" element={<LabDetailPage />} />
      <Route path="/lab/:id/poll/:pollId/results" element={<LabPollResultsPage />} />
      <Route path="/subscription" element={<SubscriptionManagePage />} />
      <Route path={ADMIN_ROUTE_PATH} element={<AdminPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
